import {useMutation} from 'react-query';
import {postWithdrawRequest} from './postWithdrawRequest';

const usePostWithdrawRequest = () => {
  return useMutation({mutationFn: postWithdrawRequest});
};

export default usePostWithdrawRequest;
